// ** Third Party Components
import { useTranslation } from "react-i18next";

// ** Styled Components
import { StyledModalItem } from "../styles";

// #####################################################

const ModalCityItem = ({
	city,
	location,
	handleLocationSelect,
	close,
	alwaysLight,
	isSelected,
	isRegister,
}) => {
	const { t } = useTranslation([
		"countries",
		"regions",
		"filtersAndSelectors",
	]);

	const { name, region_name, region_id, country, url, id } = city || {};

	// #####################################################

	return (
		<StyledModalItem
			label={name}
			onClick={() => {
				handleLocationSelect({
					cityId: id,
					cityName: name,
					regionId: region_id,
					regionName: region_name,
					country,
					distance:
						location?.distance === 0
							? 0
							: location?.distance
							? location.distance
							: 50,
					url,
					accept: true,
					isSelected,
				});
				close();
			}}
			key={id}
			alwaysLight={alwaysLight}
			isSelected={isSelected}
			$isRegister={isRegister}
		>
			<div>
				{`${name}${region_name ? `, ${region_name}` : ""}${
					country && `, ${t(`countries:${country}`)}`
				}`}
			</div>
		</StyledModalItem>
	);
};

export default ModalCityItem;

// #####################################################
